import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.googlepay_deposit,
    (googlepay_deposit) => {
        return {
            stage: googlepay_deposit.stage
        }
    }
)